module.exports = __webpack_public_path__ + "d63bc37a5e7f5b91aaa46cc029d9c262.fbx";